import React from 'react';

import Loader from '../../../common/Loader';
import useFetchLineItemNotes from './hooks/useFetchLineItemNotes';

interface LineItemNotesProps {
  lineItemId?: string;
}

const LineItemNotes = ({ lineItemId }: LineItemNotesProps): JSX.Element => {
  const { data, loading } = useFetchLineItemNotes({ lineItemId });

  if (loading) return <Loader />;

  return (
    <div>
      <p>{data}</p>
    </div>
  );
};

export default LineItemNotes;
